import { render, staticRenderFns } from "./iujptl.vue?vue&type=template&id=5dd7a834&scoped=true&"
import script from "./iujptl.vue?vue&type=script&lang=js&"
export * from "./iujptl.vue?vue&type=script&lang=js&"
import style0 from "./iujptl.vue?vue&type=style&index=0&id=5dd7a834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd7a834",
  null
  
)

export default component.exports